
import { SetupContext } from 'vue'
import FormFieldset from '@/components/block/FormFieldset.vue'
import Selectbox from '@/components/elements/InputSelectbox.vue'

export default {
  name: 'FormBirthDate',

  props: {
    value: String,
    label: String,
    patternLabel: String,
    req: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    fullYear: String,
    errorMessage: String,
    description: String
  },

  components: {
    FormFieldset,
    Selectbox
  },

  setup(props: any, context: SetupContext) {
    const birthday: { year: string; month: string; date: string } = {
      year: '',
      month: '',
      date: ''
    }

    const splitStr = props.value.indexOf('-') > -1 ? '-' : '/'
    if (props.value) {
      birthday.year = props.value.split(splitStr)[0]
      birthday.month = props.value.split(splitStr)[1]
      birthday.date = props.value.split(splitStr)[2]
    }

    const changeSelect = (type: string, value: string) => {
      if (type === 'year') birthday.year = value
      if (type === 'month') birthday.month = value
      if (type === 'date') birthday.date = value

      context.emit(
        'selection-change',
        `${birthday.year}/${birthday.month}/${birthday.date}`
      )
    }

    const setYear = () => {
      const years: Array<{
        label: string
        value: string
        selected: boolean
      }> = []

      const thisYear = new Date().getFullYear()
      const startYear = thisYear - 80
      const endYear = thisYear - 17
      if (!birthday.year) birthday.year = ''
      const selectedYear = Number(birthday.year)

      for (let i = endYear; i >= startYear; i--) {
        years.push({
          label: i !== endYear ? i + '年' : '年',
          value: i !== endYear ? `${i}` : '',
          selected: i === selectedYear
        })
      }

      return years
    }

    const setDate = (type = 'date') => {
      const arr: Array<{
        label: string
        value: string
        selected: boolean
      }> = []

      const labelText = type === 'month' ? '月' : '日'
      const endNumber = type === 'month' ? 12 : 31
      let selectedNumber = 0

      if (type === 'month' && birthday.month)
        selectedNumber = Number(birthday.month)
      if (type === 'date' && birthday.date)
        selectedNumber = Number(birthday.date)

      for (let i = 0; i <= endNumber; i++) {
        arr.push({
          label: i !== 0 ? i + labelText : labelText,
          value: i !== 0 ? ('00' + i).slice(-2) : '',
          selected: i === selectedNumber
        })
      }

      return arr
    }

    return {
      changeSelect,
      setDate,
      setYear
    }
  }
}
